import React, {useEffect, useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";
import Alert from "../../../../components/alert/alert.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputSwitch from "../../../../components/input/input-switch.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import {toast} from "react-toastify";
import myUserService from "../../../../services/web/my-user-service.js";

const initialState = {
    shareContactInfo: false,
    shareEmail: false
}

const MyUserShared = ({user, setTarget, refetch, setIsLoading}) => {
    const [deviceSelected, setDeviceSelected] = useState(null);
    const [state, setState] = useState(initialState);

    useEffect(() => {
        if (!state.shareContactInfo) {
            setState(prev => ({
                ...prev,
                shareEmail: false,
            }));

            setDeviceSelected(null);
        }
    }, [state.shareContactInfo]);

    useEffect(() => {
        setState({
            shareContactInfo: (!user.nameWar) ? false :user.shareContactInfo,
            shareEmail: (!user.nameWar || !user.email) ? false :user.shareEmail,
        });

        setDeviceSelected(user?.devices.find(d => d.id === user.shareDeviceId));

        return () => {
            setState(initialState);
            setDeviceSelected(null);
        }
    }, [user]);

    const handleChecked = (id, checked) => setState(prev => ({...prev, [id]: checked}));

    const submit = () => {
        setIsLoading(true)

        myUserService.shareContactInfo({shareContactInfo: state.shareContactInfo, shareEmail: state.shareEmail, sharedDeviceId: deviceSelected?.value ?? null})
            .then(() => {
                toast.success("Salvo com sucesso");
                setTarget("info");
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <Card>
            <Card.Body>
                <h3 className="flex gap-2 items-center">
                    <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                    Compartilhamento de dados
                </h3>

                {
                    !user.nameWar &&
                    <div className="pt-3 px-3">
                        <Alert target={"danger"}>
                            Para compartilhar os dados do agente informe o <b>nome de guerra</b>.
                        </Alert>
                    </div>
                }

                <div className={"flex justify-between h-[50px] px-[20px] items-center text-[14px] cursor-pointer"}>
                    Compartilhar com outras corporações que utilizam o Sentry

                    <InputSwitch
                        id="shareContactInfo"
                        checked={state.shareContactInfo}
                        onChange={(checked) => handleChecked("shareContactInfo", checked)}
                        disabled={!user.nameWar}
                    />
                </div>

                <hr className={"opacity-30 !m-0"}/>

                <div className={"flex justify-between h-[50px] px-[20px] items-center text-[14px] cursor-pointer"}>
                    E-mail

                    <InputSwitch
                        id="shareEmail"
                        checked={state.shareEmail}
                        onChange={(checked) => handleChecked("shareEmail", checked)}
                        disabled={!state.shareContactInfo || !user.nameWar || !user.email}
                    />
                </div>

                <hr className={"opacity-30 !m-0"}/>

                <div className={"flex justify-between h-[50px] px-[20px] items-center text-[14px] cursor-pointer"}>
                    Contato

                    <div style={{width: "250px"}}>
                        <SelectComponent
                            id="sharedDevice"
                            value={deviceSelected}
                            options={user.devices}
                            onChange={(value) => setDeviceSelected(value)}
                            isDisabled={!state.shareContactInfo || !user.nameWar}
                        />
                    </div>
                </div>

                <hr className={"opacity-30 !m-0"}/>

                <div className={"flex justify-between h-[50px] px-[20px] items-center text-[14px] cursor-pointer"}>
                    Ponto focal

                    <div className="truncate" style={{maxWidth: "250px"}} title={user?.focalPoints ? user?.focalPoints.join(", ") : ""}>
                        {
                            user?.focalPoints ? user?.focalPoints.join(", ") : ""
                        }
                    </div>
                </div>

                <div className="flex justify-end p-[15px]">
                    <Button onClick={submit} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default MyUserShared;